import { Component, Input, OnChanges } from '@angular/core';
import { Config } from '../universal-config';

@Component({
  selector: 'nns-branding-logo',
  template: `
    <div class="logo">
      <img src="{{logoSrc}}" *ngIf="!sharesLogoLink">
      <a href="{{sharesLogoLink}}" target="_blank" *ngIf="sharesLogoLink">
        <img src="{{logoSrc}}" >
      </a>
    </div>
  `,
  styles: [`
    :host{
      display: flex;
      align-items: center;
    }

    .logo{
      display: flex;
    }

    .logo img{
      max-width: 100%;
      max-height: 50px;
    }
  `]
})

export class BrandingLogoComponent implements OnChanges{
  @Input() sharesLogo;
  @Input() sharesLogoLink;
  @Input() visual;
  fileServerUrl;

  logoSrc;

  constructor(
    private config: Config,
  ) {
    this.fileServerUrl = this.config.get('BOX_URL') + '/file/';
  }

  ngOnChanges(changes) {
    if(this.visual && this.visual.isPreview) {
      this.setLogoSrc(this.visual.isPreview);
    } else {
      this.setLogoSrc(false);
    }
    if(changes.sharesLogoLink && changes.sharesLogoLink.currentValue) {
      this.setSharesLogoLink(changes.sharesLogoLink.currentValue);
    }
  }

  setLogoSrc(isPreview) {
    this.logoSrc = isPreview ? this.sharesLogo : this.fileServerUrl + this.sharesLogo;
  }

  setSharesLogoLink(link) {
    if(!(link.indexOf('http://') != -1 || link.indexOf('https://') != -1)) {
      this.sharesLogoLink = 'http://' + link;
    }
  }
}
